"use strict";
exports.__esModule = true;
var user_verification_1 = require("../../../../address-book/app/js/logic/user-verification");
angular.module('smartorg.r6.mgmts.userProfile').directive('profileEditor', ['$timeout', function ($timeout) {
        return {
            restrict: 'E',
            template: require('../../template/user-profile.html'),
            scope: {
                smartorgApi: '=astro',
                showAlert: '&?',
                callback: '&?'
            },
            link: function (scope) {
                // Create a alert method if not passed in.
                if (!scope.showAlert) {
                    scope.showAlert = function (input) {
                        alert(input.message);
                    };
                }
                if (!scope.callback) {
                    scope.callback = function () {
                    };
                }
                var showMessage = function (type, title, message) {
                    scope.showAlert({
                        type: type,
                        title: title,
                        message: message
                    });
                };
                /**
                 * Watches for change in user and
                 * shows save button when there is some change.
                 *
                 */
                scope.$watch('user', function (newVal) {
                    scope.newVal = newVal;
                    scope.verify.checkEmail();
                    scope.showSaveButton(newVal);
                    scope.showResetButton(newVal);
                }, true);
                scope.showSaveButton = function (newVal) {
                    scope.showSaveBtn = false;
                    if (newVal && scope.originalUser) {
                        if (newVal.email == "" || scope.verify.status.email > 1) {
                            scope.showSaveBtn = false;
                        }
                        else if (newVal.username != scope.originalUser.username) {
                            scope.showSaveBtn = true;
                        }
                        else if (newVal.firstname != scope.originalUser.firstname) {
                            scope.showSaveBtn = true;
                        }
                        else if (newVal.lastname != scope.originalUser.lastname) {
                            scope.showSaveBtn = true;
                        }
                        else if (newVal.email.toLowerCase() != scope.originalUser.email.toLowerCase()) {
                            scope.showSaveBtn = true;
                        }
                        else if (newVal.organization != scope.originalUser.organization) {
                            scope.showSaveBtn = true;
                        }
                        else if (newVal.phone.main != scope.originalUser.phone.main) {
                            scope.showSaveBtn = true;
                        }
                    }
                };
                scope.showResetButton = function (newVal) {
                    scope.showResetBtn = false;
                    if (newVal && scope.originalUser) {
                        if (newVal.username != scope.originalUser.username) {
                            scope.showResetBtn = true;
                        }
                        else if (newVal.firstname != scope.originalUser.firstname) {
                            scope.showResetBtn = true;
                        }
                        else if (newVal.lastname != scope.originalUser.lastname) {
                            scope.showResetBtn = true;
                        }
                        else if (newVal.email.toLowerCase() != scope.originalUser.email.toLowerCase()) {
                            scope.showResetBtn = true;
                        }
                        else if (newVal.organization != scope.originalUser.organization) {
                            scope.showResetBtn = true;
                        }
                        else if (newVal.phone.main != scope.originalUser.phone.main) {
                            scope.showResetBtn = true;
                        }
                    }
                };
                /**
                 * Definition of user object. This user only refering to
                 * current logged in user.
                 *
                 * @type {{
                 *     username: string,
                 *     firstname: string,
                 *     lastname: string,
                 *     email: string,
                 *     phone: {main: string, ext: string},
                 *     organization: string
                 * }}
                 */
                scope.user = {
                    username: "",
                    firstname: "",
                    lastname: "",
                    email: "",
                    phone: { main: "", ext: "" },
                    organization: "",
                    _id: ""
                };
                /**
                 * Save user info to server. Username is not changable but
                 * we pass it back anyway.
                 */
                scope.saveUser = function () {
                    if (!scope.verify.checkForSaving()) {
                        return;
                    }
                    if (!scope.user.organization) {
                        scope.user.organization = "";
                    }
                    scope.smartorgApi.saveUserProfile(scope.user.username, scope.user.lastname + ", " + scope.user.firstname, scope.user.email, scope.user.phone.main + ',' + scope.user.phone.ext, scope.user.organization).then(function () {
                        showMessage('success', 'Profile Saved.', 'Your profile is saved successfully');
                        scope.verify.initStatus(0);
                        scope.showSaveBtn = false;
                        scope.showResetBtn = false;
                        scope.loadData();
                        scope.callback();
                    })["catch"](function (err) {
                        showMessage('danger', "Error", err.message);
                        if (err.message.indexOf('Duplicated') >= 0) {
                            scope.verify.status.email = 3;
                            $timeout();
                        }
                    });
                };
                /**
                 * Change password. Send back old password and new one.
                 * Server side will handle checking the old password.
                 *
                 * @param oldPsw {string}
                 * @param newPsw {string}
                 */
                scope.changePassword = function (oldPsw, newPsw) {
                    scope.smartorgApi.resetPassword(oldPsw, newPsw).then(function (rs) {
                        if (rs.status === 0) {
                            $('#passwordModal').modal('hide');
                            bootbox.alert({
                                size: 'small',
                                message: "<div>" +
                                    "Your password is changed successfully. <br> " +
                                    "Please login again. </div>",
                                callback: function () {
                                    window.location.reload();
                                }
                            });
                        }
                        else {
                            scope.$broadcast('password:save_feedback', {
                                status: 1,
                                message: rs.messages.join()
                            });
                        }
                    })["catch"](function (err) {
                        showMessage('danger', "Error", err.message);
                    });
                };
                /**
                 * Load data from server then display them.
                 */
                scope.loadData = function () {
                    scope.clearInfo();
                    scope.smartorgApi.getUserProfile().then(function (userProfile) {
                        scope.showInfo(userProfile);
                        scope.showSaveBtn = false;
                        scope.showResetBtn = false;
                        // setTimeout(() => {
                        scope.$apply();
                        // });
                    })["catch"](function (err) {
                        showMessage('danger', "Error", err.message);
                    });
                };
                /**
                 * Clear up everythnig for display purpose.
                 */
                scope.clearInfo = function () {
                    scope.user = {
                        username: "",
                        firstname: "",
                        lastname: "",
                        email: "",
                        phone: { main: "", ext: "" },
                        organization: "",
                        _id: ""
                    };
                    scope.verify.initStatus(0);
                };
                /**
                 * Display user information.
                 *
                 * @param user {{}} The current user object.
                 */
                scope.showInfo = function (user) {
                    if (user) {
                        scope.user.username = user.username;
                        scope.user.email = user.email;
                        scope.user.organization = user.organisation;
                        scope.user._id = user._id;
                        if (user.name && user.name.indexOf(',') > -1) {
                            var fullname = user.name.split(',');
                            scope.user.firstname = fullname[1].trim();
                            scope.user.lastname = fullname[0].trim();
                        }
                        // Phone number
                        if (user.phone1) {
                            var phone = user.phone1.split(',');
                            scope.user.phone = {
                                main: phone[0],
                                ext: phone[1]
                            };
                            setTimeout(function () {
                                scope.$apply();
                            }, 100);
                        }
                        scope.user.email_verified = user.email_verified;
                        scope.originalUser = angular.copy(scope.user);
                    }
                };
                scope.resendVerificationEmail = function () {
                    scope.smartorgApi.updateUserEmail(scope.user.email).then(function () {
                        scope.emailResent = true;
                        $timeout();
                    })["catch"](function (err) {
                        showMessage("danger", "Error", err.message);
                    });
                };
                scope.$on('user:MY_PROFILE', function (event, args) {
                    scope.showSecurity = args.security;
                    scope.showBackButton = args.showBackButton;
                    scope.loadData();
                });
                // ===========================================================
                // Validations for saving
                // ===========================================================
                /**
                 * Verification for inputs. Only apply for username and
                 *     email at this moment.
                 *
                 * @type {{
                 *     v: smartorg.r6.mgmts.addressBook,
                 *     result: {username: boolean, email: boolean},
                 *     checkUsername: (function(): void),
                 *     checkEmail: (function(): void),
                 * }}
                 */
                scope.verify = {
                    v: user_verification_1["default"],
                    /**
                     * 0: not active,
                     * 1: active, no error except empty,
                     * 2 & more: active, error code
                     */
                    status: {
                        first: 0,
                        last: 0,
                        email: 0,
                        phone: 0
                    },
                    /**
                     * Set or clear up green check mark status.
                     *
                     * @param val {number} 0 for hiding checks. 1 for showing.
                     */
                    initStatus: function (val) {
                        scope.verify.status.first = val;
                        scope.verify.status.last = val;
                        scope.verify.status.email = val;
                        scope.verify.status.phone = val;
                    },
                    activate: function (key) {
                        scope.verify.status[key] = 1;
                    },
                    deactivate: function (key) {
                        scope.verify.status[key] = 0;
                    },
                    /**
                     * Check if everything is correct before saving.
                     *
                     * @returns {boolean} True means good to go.
                     */
                    checkForSaving: function () {
                        scope.verify.initStatus(1);
                        scope.verify.checkEmail();
                        return scope.verify.status.email == 1 &&
                            scope.user.email &&
                            scope.verify.status.phone == 1;
                    },
                    /**
                     * Use super dummy function to check email.
                     */
                    checkEmail: function () {
                        scope.verify.status.email = 1;
                        if (!scope.verify.v.verifyEmail(scope.user.email)) {
                            scope.verify.status.email = 2;
                        }
                        else if (scope.user.email == scope.originalUser.email) {
                            scope.verify.status.email = 1;
                        }
                        else {
                            scope.smartorgApi.checkUserEmail(scope.user).then(function (status) {
                                scope.verify.status.email = status ? 3 : 1;
                                scope.showSaveButton(scope.newVal);
                                scope.showResetButton(scope.newVal);
                                scope.$apply();
                            })["catch"](function (err) {
                                showMessage('danger', "Server Error " + err.status, "Failed to check user email. " + err.message);
                            });
                        }
                    }
                };
                scope.back = function () {
                    scope.$emit('workbench:back');
                };
            }
        };
    }]);
//# sourceMappingURL=user-profile-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/user-profile/app/js/plumbing/user-profile-directive.js